import { View } from 'backbone.marionette';
import Radio from 'backbone.radio';
import { User } from '../../models';
import { getSponsorLogo, Secret } from '../../utils';
import UserModel from "../../models/User";

const menuChannel   = Radio.channel( 'menu' );
const headerChannel = Radio.channel( 'header' );
const appViewChannel = Radio.channel('appView');

const IS_PRE_SEASON = Secret.is_passed ? false : JSON.parse(process.env.IS_PRE_SEASON || 'false');

export default class CoreHeaderView extends View {

	get className() {
		return 'site-header';
	}

	ui() {
		return {
			open_menu: '.js-open-main-menu'
		};
	}

	events() {
		return {
			'click @ui.open_menu': 'openMenu'
		};
	}

	regions() {
		return {
			menu: '#menu'
		};
	}

	initialize() {
		this.model = User;
		this.model.setUserAvatar();
		this.model.set({
			is_off_season: IS_PRE_SEASON,
			is_show_sponsor: this.model.is_adult
		});

		this.setSponsorLogo()
			.checkUserId()
			.initListeners();
	}

	setSponsorLogo() {
		let sponsor_logo = getSponsorLogo();
		this.model.set( 'sponsor_logo', sponsor_logo );

		return this;
	}

	initListeners() {
		this.listenTo( this.model, 'change:id', this.updateView );
		this.listenTo( headerChannel, 'header:update', this.updateView );
		this.listenTo( appViewChannel, 'hide', this.destroy );
		this.listenTo(UserModel, 'user:logged:in', this.updateView);
		return this;
	}

	checkUserId() {
		if ( !this.model.get( 'id' ) ) {
			this.model.set( {
				id: null
			} );
		}

		return this;
	}

	updateView() {
		this.model.setUserAvatar();
		this.model.set({
			is_off_season: IS_PRE_SEASON,
			is_show_sponsor: this.model.is_adult
		});
		this.setSponsorLogo()
			.checkUserId()
			.render();

		return this;
	}

	openMenu() {
		menuChannel.trigger( 'menu:open' );
	}
}